// Modal id the "Reserve Gear" flow uses. The product page's Reserve button opens
// it via `?modal=reserve-gear&product=<slug>&size=<size>`; the ReserveGearDialog
// (rendered by the shopProduct section) opens when the query matches its product.
export const RESERVE_GEAR_MODAL_ID = "reserve-gear";